import {Nav} from "react-bootstrap";
import "./Footer.scss";
import {Link} from "react-router-dom";

const Footer = () => {
    return (
        <>
            <footer className="bg-color text-white pt-4">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <h5>Über uns</h5>
                            <p>
                                Bei Wärmepumpen & Klimatechnik Bilke sind wir auf die
                                Bereitstellung energieeffizienter Heiz- und Kühllösungen
                                spezialisiert, die auf Ihre Komfortbedürfnisse zugeschnitten
                                sind.
                            </p>
                        </div>

                        <div className="col-md-4">
                            <h5>Links</h5>
                            <Nav className="flex-column">
                                <Nav.Link as={Link} to="/" className="Footer-link">
                                    Startseite
                                </Nav.Link>
                                <Nav.Link as={Link} to="/Company" className="Footer-link">
                                    Unternehmen
                                </Nav.Link>
                                <Nav.Link as={Link} to="/References" className="Footer-link">
                                    Referenzen
                                </Nav.Link>
                                <Nav.Link as={Link} to="/Contact" className="Footer-link">
                                    Kontakt
                                </Nav.Link>
                                <Nav.Link as={Link} to="/Impresspage" className="Footer-link">
                                    Impressum
                                </Nav.Link>
                            </Nav>
                        </div>

                        <div className="col-md-4">
                            <h5>Kontaktieren Sie uns</h5>
                            <p>Email: info@wk-bilke.de</p>
                            <p>Tel: +49 172 3762581</p>
                            <p>Adresse: Wilhelm Pieck Straße 58, 06647 Finneland OT Saubach</p>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col text-center">
                            <p className="mb-0">
                                &copy; 2024 Wärmepumpen & Klimatechnik Bilke GmbH. Alle Rechte vorbehalten.
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};
export default Footer;
